import { useState } from 'react';
import { StarFilled, StarOutlined } from '../../assets/images/svgs';

interface StarButtonBaseProps {
  isFavorite: boolean;
  onToggle: () => void;
  isLoading?: boolean;
  className?: string;
}

export const StarButtonBase: React.FC<StarButtonBaseProps> = ({
  isFavorite,
  onToggle,
  isLoading = false,
  className = '',
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const backgroundColor =
    isHovered && !isFavorite ? 'rgb(var(--color-button-secondary-hover))' : 'rgba(255, 255, 255, 0.6)';
  const starColor = isFavorite ? 'rgb(var(--color-primary))' : 'rgb(var(--color-muted-text-gray))';

  return (
    <button
      onClick={onToggle}
      disabled={isLoading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`flex h-10 w-10 items-center justify-center rounded-full border border-[rgba(144,161,185,0.6)] disabled:opacity-50 ${className}`}
      style={{ backgroundColor }}
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
    >
      <div>{isFavorite ? <StarFilled color={starColor} /> : <StarOutlined color={starColor} />}</div>
    </button>
  );
};
